import SearchBar from './src/search-bar'
import SaveLocal from './src/save-local'

SearchBar.install = function(Vue) {
    Vue.component(SearchBar.name, SearchBar)
    Vue.component(SaveLocal.name, SaveLocal)
}

export default SearchBar
